// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blackout-card .customCardbody {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  -ms-flex-line-pack: start;\n      align-content: flex-start;\n}\n.blackout-card .customCardbody div {\n  max-height: 33px !important;\n}\n.blackout-card .customCardbody .line-text-left {\n  padding-bottom: 40px !important;\n  padding-top: 10px !important;\n}", ""]);
// Exports
module.exports = exports;
